var map = {
	"./arg.svg": 936,
	"./aus.svg": 937,
	"./bel.svg": 938,
	"./bra.svg": 939,
	"./can.svg": 940,
	"./cmr.svg": 941,
	"./crc.svg": 942,
	"./cro.svg": 943,
	"./den.svg": 944,
	"./ecu.svg": 945,
	"./eng.svg": 946,
	"./esp.svg": 947,
	"./fra.svg": 948,
	"./ger.svg": 949,
	"./gha.svg": 950,
	"./irn.svg": 951,
	"./jpn.svg": 952,
	"./kor.svg": 953,
	"./ksa.svg": 954,
	"./mar.svg": 955,
	"./mex.svg": 956,
	"./ned.svg": 957,
	"./pol.svg": 958,
	"./por.svg": 959,
	"./qat.svg": 960,
	"./sen.svg": 961,
	"./srb.svg": 962,
	"./sui.svg": 963,
	"./tun.svg": 964,
	"./uru.svg": 965,
	"./usa.svg": 966,
	"./wal.svg": 967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;